var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__("common.labels.address"),
            error: _vm.getErrorMsg,
            orientation: _vm.orientation
          }
        },
        [
          _c("CompassInput", {
            ref: "jawgInput",
            attrs: { error: !!_vm.errorMsg },
            on: {
              input: function($event) {
                return _vm.$emit("input")
              },
              "update:value": _vm.handleUpdateValue
            },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            isVisible: _vm.isVisible,
            triggerRef: "jawgInput",
            placement: "bottom-start",
            isTriggerWidth: true
          },
          on: {
            close: function($event) {
              _vm.isVisible = false
            }
          }
        },
        [
          _c("div", {
            ref: "autocompleteAddressResults",
            staticClass:
              "autocomplete-address__results typographies-paragraph-medium-regular"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }